import { render, staticRenderFns } from "./addGoodsSku.vue?vue&type=template&id=29c99179&scoped=true"
import script from "./addGoodsSku.vue?vue&type=script&lang=js"
export * from "./addGoodsSku.vue?vue&type=script&lang=js"
import style0 from "./addGoodsSku.vue?vue&type=style&index=0&id=29c99179&prod&lang=scss"
import style1 from "./addGoodsSku.vue?vue&type=style&index=1&id=29c99179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c99179",
  null
  
)

export default component.exports